var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
export var listChannelsGql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query listChannels($tubeId: String!, $action: String!) {\n    channels(id: $tubeId, action: $action)\n      @rest(type: \"[ChannelList]\", path: \"/listchannels?tubeId=:id&action=:action\", endpoint: \"query\") {\n      parent\n      id\n      name\n      abstract\n      description\n      icon\n      orgId\n      canUpdate\n      videosCount\n      tracksCount\n      shared\n      sharedWith\n      sourceOrgId\n      channelIcon\n      backgroundImage\n      backgroundColor\n      isChannelExternalShareEnabled\n      externalShareAllowedDomains\n      featuredVideosForRecommendations\n      featuredVideoRecommendationGenerationOn\n      owners\n      createdAt\n      status\n    }\n  }\n"], ["\n  query listChannels($tubeId: String!, $action: String!) {\n    channels(id: $tubeId, action: $action)\n      @rest(type: \"[ChannelList]\", path: \"/listchannels?tubeId=:id&action=:action\", endpoint: \"query\") {\n      parent\n      id\n      name\n      abstract\n      description\n      icon\n      orgId\n      canUpdate\n      videosCount\n      tracksCount\n      shared\n      sharedWith\n      sourceOrgId\n      channelIcon\n      backgroundImage\n      backgroundColor\n      isChannelExternalShareEnabled\n      externalShareAllowedDomains\n      featuredVideosForRecommendations\n      featuredVideoRecommendationGenerationOn\n      owners\n      createdAt\n      status\n    }\n  }\n"])));
export var listChannelsData = function (action) {
    return graphql(listChannelsGql, {
        options: {
            variables: {
                action: action,
                tubeId: localStorage.getItem('tubeId'),
            },
        },
        props: function (_a) {
            var data = _a.data;
            return ({
                listChannelsQuery: data,
            });
        },
    });
};
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/queries/listChannels.ts
// module id = 426
// module chunks = 81